// extracted by mini-css-extract-plugin
export default {"button-wrapper":"styles_button-wrapper__hk7gf","badge":"styles_badge__nFcIs"};